module.exports = (__parcel__import__("kRqIf")).then(() => parcelRequire('emu4l'));